export function PenIcon() {
  return (
    <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Subtract">
        <path
          d="M9.63388 0.366116C9.14573 -0.122039 8.35427 -0.122039 7.86612 0.366116L7.31509 0.917143L9.08286 2.68491L9.63388 2.13388C10.122 1.64573 10.122 0.854271 9.63388 0.366116Z"
          fill="#292E3A"
        />
        <path
          d="M8.57778 3.18998L6.81002 1.42222L1.02391 7.20833C0.7302 7.50203 0.514301 7.8643 0.395719 8.26238L0.0148723 9.54089C-0.0225658 9.66657 0.0118852 9.80266 0.104613 9.89538C0.197342 9.98811 0.333431 10.0226 0.459111 9.98513L1.73763 9.60428C2.13571 9.48569 2.49797 9.26979 2.79168 8.97609L8.57778 3.18998Z"
          fill="#292E3A"
        />
      </g>
    </svg>
  );
}
